// workaround : https://github.com/m00s/angular-photoswipe

import "./media-infos-sidenav/media-infos-sidenav.component";
import "./media-gallery-sidenav/media-gallery-sidenav.component";

import { MediaGalleryService } from "./media-gallery.service";
import { MediaGalleryController } from "./media-gallery.controller";

angular
    .module("thor.shared.media-gallery.component", [
        "thor.shared.media-infos-sidenav.component",
        "thor.shared.media-gallery-sidenav.component"
    ])
    .service("mediaGalleryService", MediaGalleryService)
    .component("mediaGallery", {
        controller: MediaGalleryController,
        controllerAs: "mediaGalleryCtrl",
        template: require("../../shared/media-gallery/media-gallery.html")
    });
